"use client";

import { createContext, type ReactNode, useContext } from "react";

const EventYearContext = createContext<number | null>(null);

export function EventAnalyticsProvider({ children, year }: { children: ReactNode; year: number }) {
  return <EventYearContext value={year}>{children}</EventYearContext>;
}

export function useAnalyticsEventYear(): number | null {
  return useContext(EventYearContext);
}
